import dateFormatter from './dateFormatter';

const dateCellFormatter = ({ value }) => dateFormatter(value);

export default dateCellFormatter;
